import React from 'react';
import { useTranslation } from "react-i18next";
import { useAuth } from '../../../context/AuthContext';

const GeneralProfile = () => {
    const { t } = useTranslation();
    const { user } = useAuth();

    function handleSubmit(event) {
        event.preventDefault();
        // mevcut mimariye dokunmadım
    }

    return (
        <div className="container my-5">
            <div className="row justify-content-center">
                <div className="col-md-6">

                    <div className="card shadow-sm">
                        <div className="card-body">

                            <h3 className="text-center mb-4">
                                {t("profile")}
                            </h3>

                            <form onSubmit={handleSubmit}>

                                <div className="mb-3">
                                    <label
                                        htmlFor="name"
                                        className="form-label"
                                    >
                                        {t("namesurname")}
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        id="name"
                                        defaultValue={user.user.fullName}
                                    />
                                </div>

                                <div className="mb-4">
                                    <label
                                        htmlFor="email"
                                        className="form-label"
                                    >
                                        {t("email")}
                                    </label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        id="email"
                                        defaultValue={user.user.username}
                                        disabled
                                    />
                                </div>

                                <div className="d-grid">
                                    <button
                                        type="submit"
                                        className="btn btn-primary btn-lg"
                                    >
                                        {t("update")}
                                    </button>
                                </div>

                            </form>

                        </div>
                    </div>

                    <hr className="mt-4" />

                </div>
            </div>
        </div>
    );
};

export default GeneralProfile;
